import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getCookie, removeCookie } from "typescript-cookie";
import { UserSession } from "../../types/Usuario/UserSession";
import { decodeTokenCast, expirationTokenAuth } from "../../utils/jwtUtils";
import { GetVoidLoggedUser, LoggedUser, mapTokenData } from "../../types/Usuario/LoggedUser";

const initialState: UserSession = {
    isAuth:
        getCookie('token') !== undefined
            ? !expirationTokenAuth(getCookie('token') ?? '')
            : false,
    rol: "",
    token: getCookie('token') !== undefined && !expirationTokenAuth(getCookie('token') ?? '') ? getCookie('token') : '',
    userData: getCookie('token') !== undefined && !expirationTokenAuth(getCookie('token') ?? '') ? mapTokenData(decodeTokenCast<LoggedUser>(getCookie('token') ?? ''), getCookie('token') ?? '') : GetVoidLoggedUser(),
    isLoading: getCookie('token') === undefined,
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        inUser: (state, action: PayloadAction<UserSession>) => {
            const { token, userData, rol } = action.payload;
            if (token) {
                state.isAuth = true;
                state.token = token;
                state.userData = userData;
                state.rol = rol;
            }
        },
        outUser: (state) => {
            state.isAuth = false;
            state.token = '';
            state.rol = '';
            state.userData = GetVoidLoggedUser();
            removeCookie('token');
        },
    }
})

export const { inUser, outUser } = authSlice.actions;